import { Injectable } from '@angular/core';
import { ApiService } from '@app/core/services/api.service';
import { IPortfolioCompany } from '@common/models/IPortfolioCompany';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MetricMappingsService {

  constructor(private readonly apiService: ApiService) { }
   public getSectionMetrics(section: string, company: IPortfolioCompany): Observable<any> {
          const url = `metricmappings/section-metrics`;
          return this.apiService.post(url, {
              section,
              company
            }
        );
   }
}
